import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from 'reactstrap';



import { Link } from 'react-router-dom';
import { DepartmentData } from './DepartmentData.js';

import CustomDataTable from '../../../../Components/CustomTable/CustomTable.jsx';
import BreadCrumb from '../../../../Components/Common/BreadCrumb.js';



const DepartmentPage = () => {
 const [searchTerm, setSearchTerm] = useState('');
  const [loading,setLoading] = useState(false)
   const [dataList, setDataList] = useState([]);
   const [data,setData] =  useState()
  useEffect(()=>{
      const fetchData = async () => {
      try {
        const result = await DatabaseMgmt.getAll();
        setDataList(result);
      } catch (error) {
        console.error("Failed to load data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  },[])
  
  console.log(dataList)
  const [filterText, setFilterText] = useState('');
  const [addModal, setAddModal] = useState(false);
 

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = DepartmentData.filter(doc => 
        doc.departmentName.toLowerCase().includes(searchTerm.toLowerCase())
);
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
      width: "max-content",  
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};


  const columns = [
    {
      name: 'Department Code',
      selector: (row)=> row.departmentCode,
      width:"175px",
      sortable: true
    },
     {
      name: 'Department Name',
      selector: (row)=> <span title={row.departmentName}>
              <Link to={`/department/detail/${row.departmentCode}`}>
      
                {row.departmentName}
              </Link>
              </span>,
      width:"180px",
      sortable: true
    },
    {
      name: 'HOD',
      selector: (row) =>  <span title={row.headOfDepartment}>
          {row.headOfDepartment}
        </span>,
      sortable: true
    },
    {
      name: 'Branch Assigned',
      selector: (row) => row.branchAssigned,
      width:"175px",
      sortable: true
    },
    {
      name: 'Total Employees',
      selector: (row) => row.totalEmployees,
      width:"175px",
      sortable: true,
       center: true
    },
    {
      name: 'Active Disputes',
      selector: (row) => row.activeDisputes,
      width:"175px",
      sortable: true,
       center: true
    },
    {
      name: 'Resolved Disputes',
      selector: (row) => row.resolvedDisputes,
      width:"180px",
      sortable: true,
      center: true
    },
    {
      name: 'Email',
      selector: (row) =>
      <span title={row.email}>
          {row.email}
        </span>,
      sortable: true
    },
      {
      name: 'Status',
      selector: (row) => row.status,
      width:"105px",
      sortable: true,
       cell: (row) => (
        <div
          className={`btn btn-sm ${
            row.status ? "btn-success" : "btn-danger"
          }`}
          onClick={() => console.log("Button clicked for", row)}
        >
          {row.status ? "Active" : "Inactive"}
        </div>
      ),
    },
    {
     name: "Action",
     width:"105px",
      selector: (row) => (
        <div>
          <Link to={`/updateForm/department`}>
          
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            // onClick={() => {
            //   setAddModal(true);
            //   // setSelectedCustomer(row);
            // }}
          >
            <i className="ri-edit-line" />
          </Button>
          </Link>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            // onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    }
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Department List" pageTitle="Department" />
      </div>
      
      <Row>
        <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by Department Name"
             alue={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <Link to={`/addForm/department`}>
          
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Add Department
          </button>
          </Link>
        </Col>
        <Col
          md={4}
          xs={2}
          className="d-flex d-lg-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success"
            onClick={() => setAddModal(true)}
          >
            +
          </button>
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                {/* <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                /> */}
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>ID:</strong> {item.id}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Name:</strong> {item.dbName}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Server:</strong> {item.dbServer}
                    </h6>
                    <h6 className="mb-2">
                      <strong>User:</strong> {item.dbUser}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Description:</strong> {item.description}
                    </h6>
                     {item.status?(<button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            Active
          </button>):(<button
            className="btn btn-danger px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            InActive
          </button>)}
                   
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}

export default DepartmentPage
